import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./Viewer.module.css";
import { PatternlibButton, PatternlibIcon } from "@liebherr/patternlib-react";

const Viewer = ({ part }) => {
  const [fullScreen, setFullScreen] = useState(false);
  const event = new CustomEvent("hyzUpdate", { bubbles: true, detail: part });
  useEffect(() => {
    // Dispatch/Trigger/Fire the event
    if (Object.keys(part).length !== 0) {
      window.dispatchEvent(event);
    }
  }, [part?.varset, fullScreen]);

  const toFullScreen = () => {
    window.cnsWebViewerModal.showModal(); // Open the modal
    setFullScreen(true);
  };
  const closeFullScreen = () => {
    window.cnsWebViewerModal.close(); // Close the modal
    setFullScreen(false);
  };

  const escHandler = (e) => {
    if (e.key === "Escape") {
      closeFullScreen();
    }
  };

  return (
    <div className={styles.container} onKeyUp={escHandler}>
      <div className={styles.cnsWebViewerContainer}>
        <button onClick={toFullScreen} className={styles.fullScreenBtn}>
          <PatternlibIcon icon-name="move" size="24px" slot="icon" />
        </button>
        {!fullScreen && (
          <div id="cnsWebViewer" className={styles.cnsWebViewer}></div>
        )}
      </div>
      <dialog id="cnsWebViewerModal" className={styles.modal}>
        <form method="dialog" className={styles.dialog}>
          <PatternlibButton
            type="secondary"
            onClick={closeFullScreen}
            className={styles.closeBtn}
          >
            <PatternlibIcon icon-name="x" size="24px" slot="icon" />
          </PatternlibButton>
          <div id="cnsWebViewer" className={styles.cnsWebViewer}></div>
        </form>
      </dialog>
    </div>
  );
};

Viewer.propTypes = {
  part: PropTypes.object,
};

export default Viewer;
